import classNames from 'classnames';
import { FC, useState } from 'react';
import Switch from 'react-bootstrap-switch';

type Props = {
  value: boolean;
  onText: string;
  offText: string;
  saveLabel: string;
  onSave: (value: boolean) => Promise<void>;
  isWide?: boolean;
  disabled?: boolean;
};

/** A table switch that only saves after an explicit Save click, so a stray toggle changes nothing. */
export const TableSwitchCell: FC<Props> = ({
  value,
  onText,
  offText,
  saveLabel,
  onSave,
  isWide,
  disabled,
}) => {
  const [pendingValue, setPendingValue] = useState<boolean | null>(null);
  const [isSaving, setIsSaving] = useState(false);
  const displayValue = pendingValue ?? value;
  const hasChanged = displayValue !== value;

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await onSave(displayValue);
    } finally {
      setPendingValue(null);
      setIsSaving(false);
    }
  };

  return (
    <div className="stripe-authorized-cell">
      <div>
        <Switch
          value={displayValue}
          onColor="success"
          onText={onText}
          offColor="success"
          offText={offText}
          handleWidth={500}
          wrapperClass={classNames('wrapper', { 'oath-switch--wide': isWide })}
          disabled={disabled || isSaving}
          onChange={event => setPendingValue(event.state?.value ?? !displayValue)}
        />
      </div>
      {hasChanged && (
        <button
          type="button"
          className="table-action-link inkBlue padding0"
          onClick={handleSave}
          disabled={isSaving}
          aria-label={saveLabel}
        >
          <span>Save</span>
        </button>
      )}
    </div>
  );
};
